import type * as React from 'react';

import { cn } from '@/lib/utils';

/**
 * `avatar` : carré arrondi 28px (initiales 11px) sur `muted`, filet `border`.
 * `CellUser` : avatar + cellule deux lignes (`cell-user` des maquettes).
 */
function Avatar({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLSpanElement>): React.JSX.Element {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'grid size-7 shrink-0 place-items-center rounded-md border border-border bg-muted text-[11px] font-medium leading-4 text-foreground',
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}

function CellUser({
  initials,
  children,
  className,
}: {
  initials: string;
  children: React.ReactNode;
  className?: string;
}): React.JSX.Element {
  return (
    <div className={cn('flex min-w-0 items-center gap-3', className)}>
      <Avatar>{initials}</Avatar>
      {children}
    </div>
  );
}

export { Avatar, CellUser };
